const defaultState = {};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'OUTGOING_FAXES_SUCCESS':
            return action.outgoingFaxes;
        default:
            return state;
    }
}
